/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import React, { useContext, useCallback, useState, useEffect } from 'react'
import _, { isUndefined } from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import metadata from './DwellingAnimals.metadata.json5';
import styles from './DwellingAnimals.module.scss';
import messages from './DwellingAnimals.messages.js';


function DwellingAnimals(props) {
    const { data: animalVM, isInvalid, dwellingVM, dwellingDeleteAnimals, showErrors, onValidate } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const [animalDataVM, updateAnimalDataVM] = useState(animalVM);
    const [trainedGuard, setTrainedGuard] = useState(false);
    const [breedValidation, setBreedValidation] = useState([]);
    const { refreshData } = useDataRefresh();
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('DwellingAnimals');

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'RoofDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        isInvalid(isComponentValid, 'RoofDetails')
    }, [isComponentValid, isInvalid]);


    const deletesAnimal = useCallback(() => {
        let idx;
        if (animalVM.value.publicID) {
            idx = _.findIndex(dwellingVM.value.dwellingAnimals, (animal) => animal.publicID === animalVM.value.publicID);
        } else {
            idx = _.findIndex(dwellingVM.value.dwellingAnimals, (animal) => animal.tempID === animalVM.value.tempID);
        }
        dwellingVM.value.dwellingAnimals.splice(idx, 1);
        dwellingDeleteAnimals(dwellingVM)
        updateAnimalDataVM(animalVM);
       

    }, [animalVM, dwellingDeleteAnimals, dwellingVM])


    const writeValue = useCallback(
        (value, path) => {
            _.set(animalDataVM, path, value);
            if(!_.isUndefined(animalDataVM.animalBreed.aspects.validationMessage)) {
                setBreedValidation([translator(messages.breedMessage)])
            }
            // DE16204
            if(_.includes(path, 'animalType') && value === 'Other'){
                _.set(animalDataVM, 'animalBreed.value', undefined)
                setBreedValidation([])
            }
            updateAnimalDataVM(animalDataVM);
            refreshData();
        }, [animalDataVM, refreshData, translator]
    );

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true
        },
        // DE16149
        trainedAsGuard: {
            visible: animalDataVM?.value.animalType === "Dog"
        },
        // DE16202
        breed: {
            validationMessages: !_.isUndefined(animalDataVM.animalBreed.aspects.validationMessage)  ? breedValidation : [],
            readOnly: _.isUndefined(animalDataVM?.value.animalType)
        }
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            deletesAnimal
        },
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={animalVM}
            showErrors={showErrors}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />

    )
}

export default DwellingAnimals